import { render, staticRenderFns } from "./SlickList.vue?vue&type=template&id=2a6b2e3b&scoped=true&"
import script from "./SlickList.vue?vue&type=script&lang=js&"
export * from "./SlickList.vue?vue&type=script&lang=js&"
import style0 from "./SlickList.vue?vue&type=style&index=0&id=2a6b2e3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b2e3b",
  null
  
)

export default component.exports